import { useState } from 'react';
import { api } from '@/lib/api';

export function LandingPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/magic-link', { email });
      setSent(true);
    } catch (err: any) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand-200 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-3">
            <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-md">
              <span className="text-2xl">∿</span>
            </div>
            <h1 className="text-3xl font-bold text-vibe-500" style={{ letterSpacing: '0.02em' }}>vibration</h1>
          </div>
          <p className="text-sand-500 text-sm">Your local social network</p>
        </div>

        {/* Card */}
        <div className="card p-6">
          {sent ? (
            <div className="text-center py-4">
              <div className="text-3xl mb-3">📬</div>
              <h2 className="font-bold text-lg text-sand-800 mb-2">Check your email</h2>
              <p className="text-sand-500 text-sm">
                We sent a sign-in link to <strong className="text-sand-700">{email}</strong>.
                Click the link to get in.
              </p>
              <button
                onClick={() => { setSent(false); setEmail(''); }}
                className="mt-4 text-vibe-500 text-sm hover:underline"
              >
                Use a different email
              </button>
            </div>
          ) : (
            <>
              <h2 className="font-bold text-lg text-sand-800 mb-1">Sign in or create account</h2>
              <p className="text-sand-500 text-xs mb-4">No password needed — we'll email you a link.</p>

              <form onSubmit={handleSubmit}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="input w-full mb-3"
                  autoFocus
                />
                {error && <p className="text-red-600 text-xs mb-3">{error}</p>}
                <button
                  type="submit"
                  disabled={loading}
                  className="btn-primary w-full disabled:opacity-50"
                >
                  {loading ? 'Sending...' : 'Send sign-in link'}
                </button>
              </form>
            </>
          )}
        </div>

        <p className="text-center text-sand-500 text-xs mt-6">
          By signing in you agree to our Terms of Service and Privacy Policy.
        </p>
      </div>
    </div>
  );
}
